import { authentication } from "./authentication";
import { externalPage } from "./externalPage";
import { footer } from "./footer";
import { profile } from "./profile";

export const TranslationToEnglish = {
  ...authentication,
  ...footer,
  ...profile,
  ...externalPage,
};
